export const CV = {
    hero: {
      name: "Adrian",
      lastName: "Torres Serrano",
      city: "Madrid, Madrid",
      email: "adriat1994@gmail.com",
      birthDate: "21/12/1994",
      phone: "(+34) 6491257261",
      image: "https://media-exp1.licdn.com/dms/image/C4D03AQHp1fhzyox3FA/profile-displayphoto-shrink_200_200/0/1537103305085?e=1648080000&v=beta&t=VS1_5uDedb0ql_pLf7JXjV3XNRyV9FjnUEsOLwA5-1Q",
      gitHub: "https://github.com/Adriat1994",
      linkedIn: "www.linkedin.com/in/adrián-torres-serrano-a2519a141",
      aboutMe: [
        {
          info: "Experiencia en laboratorios de análisis microbiológico y organoléptico, en el sector de la alimentación y la salud.",
        },
        {
          info: "Alto dominio del inglés, tanto escrito como hablado.",
        },
        {
          info: "Grandes capacidades para trabajar en grupo y buena comunicación.",
        },
        {
          info: "Actualmente estudiando para ser full stack developer.",
        },
      ],
    },
    education: [
      {
        name: "Master en calidad, medio ambiente y PRL",
        date: "2019-2021",
        where: "IMF Business School",
      },
      {
        name: "Grado en Ciencia y Tecnología de los alimentos",
        date: "2014-2018",
        where: "Universidad Complutense de Madrid",
      },
      {
        name: "Formación Profesional en Salud Ambiental",
        date: "2012-2014",
        where: "Instituto Leonardo Da Vinci",
      },
    ],
    experience: [
      {
        name: "Departamento técnico y de calidad",
        date: "Noviembre 2018 – Septiembre 2021",
        where: "500Cosmetics By Natural Logistics",
        description:
          "Realización de planes de gestión logística para envíos a nivel mundial, desarrollo de nuevos productos, redacción de documentación legal sobre los productos vendidos por la empresa a nivel mundial, gestión de proveedores.",
      },
      {
        name: "Técnico de control de calidad",
        date: "Abril 2018 – Junio 2018",
        where: "Aperitivos Medina",
        description:
          "Realización de fichas técnicas de producto, control de proveedores, redacción del sistema APPCC",
      },
      {
        name: "Sales assistant",
        date: "Junio 2017 – Agosto 2017",
        where: "Kingdom of Sweets",
        description:
          "Venta de producto y trato directo con el cliente, organización de productos y reposición de stock.",
      },
      {
        name: "Técnico de laboratorio",
        date: "Marzo 2014 – Junio 2014",
        where: "Water Services Corporation",
        description:
          "Muestreo de aguas públicas, preparación y acondicionamiento de muestras, análisis organoléptico y microbiológico de aguas",
      }
    ],
    languages: [
        {
        language: "Español",
        wrlevel: "Nativo",
        splevel: "Nativo",
        },
        {
        language: "Inglés",
        wrlevel: "Avanzado",
        splevel: "Avanzado",
        }
    ],
    habilities: [
      "Pensamiento creativo",
      "Trabajo en equipo",
      "Estrategia empresarial",
      "liderazgo de equipos",
      "Empatía"      
    ],
    projects: [
      {
        name: "Cerveza 0.0",
        description: "El proyecto desarrollado consiste en la elaboración de cerveza 0,0. Esto surge a raid de que la producción íntegra va a ser destinada a países de población islámica, por lo que para poder vender nuestro producto los contenidos de alcohol en el producto final tienen que ser inferiores al 0,01 cumpliendo así la ley islámica. Los países a los que va enfocado el producto son los países pertenecientes a Oriente Medio, siendo los principales Emiratos Árabes Unidos, Irak e Israel."
      },
      {
        name: "Prevención de riesgos laborales en una línea de producción de patata frita",
        description: "Se evaluó si la gestión en materia de PRL de una línea de procesado de patata frita en una industria de aperitivos se realizaba de forma correcta, de acuerdo con los procedimientos establecidos por el Instituto Nacional de Seguridad e Higiene en el Trabajo. Para ello, en primer lugar, se analizó el plan de PRL existente en dicha línea, comprobando in situ la implantación de las medidas preventivas recogidas en este plan y su eficacia en la reducción de riesgos. Posteriormente, se revaluaron los riesgos y se propusieron medidas preventivas para mejorar el control de aquellos asociados a peligros insuficientemente controlados."
      }
    ]    
  };